import { useSidebar } from '@/components/ui/sidebar'

/** the count on a sidebar row. two forms, because a collapsed rail has no
 *  label to sit beside: a dot over the icon, or a pill at the end of the row.
 *
 *  the collapsed form is positioned against its icon, so wrap the icon in
 *  `relative inline-flex` and render this next to it.
 */
export function SidebarCountBadge({
  count,
  variant
}: {
  count: number
  variant: 'dot' | 'pill'
}) {
  const collapsed = useSidebar().state === 'collapsed'
  if (count <= 0) return null
  if (variant === 'dot') {
    if (!collapsed) return null
    return (
      <span className='absolute -top-1 -right-1 inline-flex h-3 min-w-[12px] items-center justify-center rounded-full bg-accent px-0.5 text-[8px] leading-none font-semibold text-white'>
        {count > 9 ? '9+' : count}
      </span>
    )
  }
  if (collapsed) return null
  return (
    <span className='ml-auto inline-flex h-5 min-w-[20px] items-center justify-center rounded-full bg-accent px-1.5 text-[10px] leading-none font-semibold text-white'>
      {count > 99 ? '99+' : count}
    </span>
  )
}
